import * as React from 'react'
import '../SecondLevel.scss'

const AllArticles = () => {

    return (
        <div className='second-level'>
            <div className='second-level__title'>
                В настоящее время раздел находится в разработке
            </div>
        </div>
    )
}

export default AllArticles;